<template>
    <div class="text-center logo-outer">
        <img class="logo" title="Pimblr" src="../../assets/PimblrLogoLarge.png"/>
    </div>
</template>

<script>
    export default {
        name: '',
        data() {
            return {}
        },
        created() {
        },
        methods: {}
    }
</script>

<style lang="sass" scoped>


    .logo
        max-width: 300px
        height: auto
        margin: 2em auto 3em
</style>


// WEBPACK FOOTER //
// src/components/layout/CenterLogo.vue